export default "__VITE_ASSET__Cg1Uxuon__"